import { APP_REGION, POOL_ID, CLIENT_ID } from "./constants";

export const AWS_CONFIG = {
  region: APP_REGION,
  identityPoolRegion: APP_REGION,
  userPoolId: POOL_ID,
  userPoolWebClientId: CLIENT_ID,
  clientMetadata: {},
};
